export default [
  {
    path: `/:slug`,
    name: "Page",
    component: () =>
      import(/* webpackChunkName: "main" */ "./views/Page.vue")
  },
];
